import { SupplementaryInsuranceConfigurationTexts } from '../supplementary-insurance-configurations';

export function mapLegalProtectionTexts(): SupplementaryInsuranceConfigurationTexts {
  return {
    productKey: 'LEGAL_PROTECTION',
    productConfig: [],
  };
}
